import { showEvaluationFeedback } from './evaluationFeedback';
import { handleAjaxError } from './handleAjaxError';
import { ACCESS_REQUIREMENT_CODES } from '../helpers/accessRequirementErrors';

/**
 * Bind click handler for .g-chatform-message-feedback-regenerate buttons.
 *
 * Shows the feedback panel first, then triggers the existing regenerate
 * handler on submit/regenerate so all DOM cleanup + AJAX logic runs once.
 *
 * @param {jQuery} element — found via wrapper.find('.g-chatform-message-feedback-regenerate')
 */
export function regenerateWithFeedbackMessage(element) {
    element.off('click.regenerateWithFeedback').on('click.regenerateWithFeedback', function (event) {
        event.preventDefault();
        event.stopPropagation();

        const btn = $(this);
        const messageElement = btn.closest('.g-chatform-message');

        // Don't open panel if regeneration is already running
        if (btn.hasClass('is-loading') || btn.hasClass('is-disabled')) {
            return;
        }

        if (!growtype_chat_ajax.is_logged_in) {
            handleAjaxError({
                responseJSON: {
                    data: {
                        message: ACCESS_REQUIREMENT_CODES.PROFILE_REQUIRED,
                    },
                },
            }, btn);
            return;
        }

        btn.addClass('is-loading');

        showEvaluationFeedback('dislike', messageElement.attr('data-id'), btn[0], {
            hideSubmit: true,

            onRegenerate: function (feedbackText) {
                btn.addClass('is-loading');
                if (feedbackText) {
                    messageElement.data('pending_feedback', feedbackText);
                }
                messageElement.find('.g-chatform-message-regenerate').trigger('click');
            },

            onSubmit: function (feedbackText) {
                btn.addClass('is-loading');
                if (feedbackText) {
                    messageElement.data('pending_feedback', feedbackText);
                }
                messageElement.find('.g-chatform-message-regenerate').trigger('click');
            },

            onCancel: function () {
                btn.removeClass('is-loading');
            }
        });
    });
}
